$(document).ready(function () {

    if ($('#permissions_table').length) {

        let url = window.location.origin + '/privilege/manager/permissions/get';

        setTimeout(function () {
            permissions_table();
        }, 500);

        function permissions_table() {

            $('#permissions_table').dataTable({
                'pageLength': 25,
                "processing": true,
                "serverSide": true,
                "ajax": url,
                "columns": [
                    {data: 'name'},
                    {data: 'guard_name'},
                    {data: 'created_at'},
                ],
                "order": [[2, 'asc']],
                "columnDefs": [
                    {
                        "targets": 3,
                        "render": function (data, type, row, meta) {
                            return "<button type='button' class='btn btn-primary btn-sm edit-permission' data-permissions='" + row + "' data-toggle='tooltip' title='Editar Permiso'><i class='fas fa-pencil-alt'></i></button> "
                                + "<button type='button' class='btn btn-danger btn-sm remove-permission' data-permissions='" + row + "' data-toggle='tooltip' title='Eliminar Permiso'><i class='fas fa-trash'></i></button> ";

                        }
                    }],
                "language": {
                    "url": window.location.origin + "/json/Spanish.json"
                },
            });

            $('#permissions_table tbody').on('click', '.edit-permission', function (e) {
                e.preventDefault();
                let table = $("#permissions_table").DataTable();
                let rowData = table.row($(this).parents('tr')).data();

                $.ajax({
                    url: window.location.origin + '/privilege/manager/permissions/' + rowData.id + '/edit',
                    type: 'GET',
                })
                    .done(function (response) {
                        document.getElementById('div_modal_permissions').innerHTML = response;
                        $('#modal-permissions').modal("show");
                    })
                    .fail(function (jqXHR, textStatus) {
                        console.log(jqXHR);
                        alert("Disculpe, existió un problema");
                    });
            });

            $('#permissions_table tbody').on('click', '.remove-permission', function (e) {
                e.preventDefault();
                let table = $("#permissions_table").DataTable();
                let rowData = table.row($(this).parents('tr')).data();

                Swal
                    .fire({
                        title: "Eliminar permiso " + rowData.name,
                        text: "¿Eliminar?",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: "Sí, eliminar",
                        cancelButtonText: "Cancelar",
                    })
                    .then(resultado => {
                        if (resultado.value) {
                            //let url = ;
                            $.ajax({
                                url: window.location.origin + '/privilege/manager/permissions/' + rowData.id,
                                type: 'DELETE',
                                headers: {
                                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                                }
                            })
                                .done(function (response) {
                                    Swal.fire('Eliminado', ' Se ha eliminado el permiso.', 'success')
                                        .then(() => {
                                            $('#permissions_table').DataTable().ajax.url(url).load();
                                        });
                                })
                                .fail(function (jqXHR, textStatus) {
                                    console.log(jqXHR);
                                    alert("Disculpe, existió un problema");
                                });
                        }
                    });
            });
        }

        document.getElementById('add_permission').onclick = function () {
            $.ajax({
                url: window.location.origin + '/privilege/manager/permissions/create',
                type: 'GET',
            })
                .done(function (response) {
                    document.getElementById('div_modal_permissions').innerHTML = response;
                    $('#modal-permissions').modal("show");
                })
                .fail(function (jqXHR, textStatus) {
                    console.log(jqXHR);
                    alert("Disculpe, existió un problema");
                });
        }

        $(document).on('click', '#send_permissions', function (event) {
            const data = $("#formPermissions").serialize();
            event.preventDefault();
            document.getElementById('div_message').innerHTML = "";
            $.ajax({
                data: data,
                url: window.location.origin + '/privilege/manager/permissions',
                type: 'POST',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            })
                .done(function (response) {
                    Swal.fire('Agregado', ' Se agrego el permiso correctamente', 'success')
                        .then(() => {
                            $('#modal-permissions').modal("hide");
                            $('#permissions_table').DataTable().ajax.url(url).load();
                        });
                })
                .fail(function (jqXHR, textStatus) {
                    //validacion de laravel a campos lo ignoramos unicamente por que entra en fail xk no pasa la validacion
                    if (jqXHR['status'] == 422) {

                        let errors = "<ul class=''>";
                        let items = "";

                        $.each(jqXHR['responseJSON']['errors'], function (index, value) {
                            items = items + "<li class='' style='text-align:left'>" + value + "</li>";
                        });

                        errors = errors + items + "</ul>";
                        let view = "<div class='row'><div class='card-body'><div class='alert alert-danger alert-dismissible'>"
                            + "<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>×</button>"
                            + "<h5><i class='icon fas fa-ban'></i> Advertencia</h5>"
                            + errors
                            + "</div></div></div>";
                        document.getElementById('div_message').innerHTML = view;
                    } else {
                        console.log(jqXHR['status']);
                        alert("Disculpe, existió un problema");
                    }
                });
        });

        $(document).on('click', '#sent_permissions_update', function (event) {
            const data = $("#formPermissions").serialize();
            let id = $("#id").val();
            //let url = window.location.origin + '/user/manager/' + id;
            event.preventDefault();
            document.getElementById('div_message').innerHTML = "";
            $.ajax({
                data: data,
                url: window.location.origin + '/privilege/manager/permissions/' + id,
                type: 'PUT',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            })
                .done(function (response) {
                    Swal.fire('Actualizado', 'Se actualizo el permiso correctamente', 'success')
                        .then(() => {
                            $('#modal-permissions').modal("hide");
                            $('#permissions_table').DataTable().ajax.url(url).load();
                        });
                })
                .fail(function (jqXHR, textStatus) {
                    //validacion de laravel a campos lo ignoramos unicamente por que entra en fail xk no pasa la validacion
                    if (jqXHR['status'] == 422) {

                        let errors = "<ul class=''>";
                        let items = "";

                        $.each(jqXHR['responseJSON']['errors'], function (index, value) {
                            items = items + "<li class='' style='text-align:left'>" + value + "</li>";
                        });

                        errors = errors + items + "</ul>";
                        let view = "<div class='row'><div class='card-body'><div class='alert alert-danger alert-dismissible'>"
                            + "<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>×</button>"
                            + "<h5><i class='icon fas fa-ban'></i> Advertencia</h5>"
                            + errors
                            + "</div></div></div>";
                        document.getElementById('div_message').innerHTML = view;
                    } else {
                        console.log(jqXHR['status']);
                        alert("Disculpe, existió un problema");
                    }
                });
        });
    }

});
